<div
	class="spinner-container initialized"
	id="au-spinner-container"
	*ngIf="active"
>
	<div id="au-spinner" class="spinner"></div>
</div>